import CustomStore from 'devextreme/data/custom_store';
import { Http } from '@angular/http';
import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { GridConfig, calculaAlturaGrid, adicionaIconesGrid, Mascaras, formataCNPJ } from './../app.config';
import { Filial } from './filial.model';
import { NTECH_API } from '../app.api';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
  selector: 'ntc-filial',
  templateUrl: './filial.component.html',
  styleUrls: ['./filial.component.css']
})
export class FilialComponent implements OnInit {
  @ViewChild(DxDataGridComponent) dataGrid: DxDataGridComponent;

  listaFilial: CustomStore;
  alturaGrid = null;

  showFilterRow = GridConfig.showFilterRow;
  currentFilter = GridConfig.currentFilter;
  showHeaderFilter = GridConfig.showHeaderFilter;
  columnChooser = GridConfig.columnChooser;
  groupPanel = GridConfig.groupPanel;
  searchPanel = GridConfig.searchPanel;
  exportGrid = GridConfig.exportGrid;

  colunasGridFilial = [
    {
      dataField: 'Id',
      dataType: 'string',
      caption: 'ID',
      editorOptions: { disabled: true }
    },
    {
      dataField: 'Nome',
      dataType: 'string',
      caption: 'Nome',
      validationRules: [{
        type: 'required',
        message: 'Nome é obrigatório.'
      }]
    },
    {
      dataField: 'Cnpj',
      dataType: 'string',
      caption: 'Cnpj',
      validationRules: [{
        type: 'required',
        message: 'Cnpj é obrigatório.'
      }],
      editorOptions: { mask: Mascaras.Cnpj },
      customizeText: formataCNPJ
    }
  ];

  editOptionsGridFilial = {
    mode: GridConfig.gridMode,
    allowUpdating: true,
    allowAdding: true,
    allowDeleting: true,
    popup: {
      title: 'Filial',
      showTitle: true
    }
  };

  constructor(@Inject(Http) http: Http) {
    this.listaFilial = new CustomStore({
      insert: function (values) {
        return http.post(`${NTECH_API}/filial/`, values).toPromise();
      },
      remove: function (key) {
        return http.delete(`${NTECH_API}/filial/${encodeURIComponent(key.Id)}`).toPromise();
      },
      update: function (key, values) {
        return http.put(`${NTECH_API}/filial/${encodeURIComponent(key.Id)}`, Object.assign(key, values)).toPromise();
      },
      load: function (loadOptions: any) {
        return http.get(`${NTECH_API}/filial/`)
            .toPromise()
            .then(response => response.json())
            .catch(error => { throw 'Erro ao carregar dados.' });
      }
    });
  }

  ngOnInit() {
    this.alturaGrid = calculaAlturaGrid();
  }

  onCellPrepared(e) {
    adicionaIconesGrid(e);
  }

  onToolbarPreparing(e) {
    const toolbarItems = e.toolbarOptions.items;

    // Adiciona um novo botao a Toolbar
    toolbarItems.push({
      location: 'after',
      widget: 'dxButton',
      options: {
          icon: 'refresh',
          onClick: this.refreshDataGrid.bind(this)
      }
    });
  }

  refreshDataGrid() {
    this.dataGrid.instance.refresh();
  }
}



// WEBPACK FOOTER //
// ./src/app/filial/filial.component.ts